import React, { FC, PropsWithChildren } from 'react';
import { ThemeProvider } from 'styled-components';
import { defaultTheme } from '@/ui/theme';
import { App as AntdApp, ConfigProvider } from 'antd';

export const AppThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const customerTheme = {
    ...defaultTheme,
  };

  return (
    <ThemeProvider theme={customerTheme}>
      <ConfigProvider
        modal={{
          centered: true,
        }}
        theme={{
          token: {
            colorBgSpotlight: '#fff',
            colorPrimary: customerTheme.primaryBg,
          },
          components: {
            Descriptions: {
              contentColor: customerTheme.textColor,
              titleColor: customerTheme.lightText,
            },
            Menu: {
              iconSize: 24,
              itemSelectedBg: '#fff',
              itemSelectedColor: customerTheme.accent,
            },
            Select: {
              optionSelectedBg: customerTheme.primaryBg10,
              optionSelectedColor: customerTheme.primaryBg,
            },
            TreeSelect: {
              nodeSelectedBg: customerTheme.primaryBg10,
              nodeSelectedColor: customerTheme.primaryBg,
            },
            Segmented: {
              itemSelectedBg: customerTheme.primaryBg,
              itemSelectedColor: '#fff',
            },
            Slider: {
              railSize: 14,
              dotSize: 14,
            },
          },
        }}
      >
        <AntdApp>{children}</AntdApp>
      </ConfigProvider>
    </ThemeProvider>
  );
};
